// the structure of a locale is defined in various RFCs, with the living Best Current Practice found at https://tools.ietf.org/html/bcp47#page-1-5
// WTFact - `i-klingon` is a perfectly valid locale: https://tools.ietf.org/html/rfc3282#section-2.1
import { startCase } from 'lodash';

const localePartsMatcher = /^([a-z]{2})(?:-([A-Z][a-z]{3}))?(?:-([A-Z]{2}))?$/i;

const canonicalCase = (token, value) => {
  switch (token) {
    case 'language':
      return value.toLowerCase();
    case 'script':
      return startCase(value.toLowerCase());
    case 'region':
      return value.toUpperCase();
    default:
      return value;
  }
};

export default function localeToParts(locale = '') {
  const parts = {};
  [, parts.language, parts.script, parts.region] =
    locale.match(localePartsMatcher) || [];
  const definedParts = Object.entries(parts).reduce(
    (definedProps, [key, value]) => ({
      ...definedProps,
      ...(value !== undefined && { [key]: canonicalCase(key, value) }),
    }),
    {},
  );

  return definedParts;
}
